export default "__VITE_ASSET__fb89ebd1__"